import React from 'react'

/**
 * Minimal error boundary. The app otherwise has NO error boundary, so any
 * uncaught render throw unmounts the whole React tree → blank white page. Wrap
 * individual, independent units (e.g. each shop card) so one malformed item
 * renders `fallback` (default: nothing) instead of taking down the entire view.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    if (typeof console !== 'undefined' && console.error) {
      console.error('[ErrorBoundary] contained a render error:', error)
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback !== undefined ? this.props.fallback : null
    }
    return this.props.children
  }
}

export default ErrorBoundary
